module.exports = __webpack_public_path__ + "static/media/notebook.1faaecaf.png";